/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		specific_overview.onready();

		specific_form.onready();
		specific_koopovereenkomst.onready();
		specific_opleveringsformulier.onready();
		specific_measuredocument.onready();
		specific_signature.onready();
		specific_photos.onready();
		specific_documents.onready();
		
		/*
		Push test
		*/
		if (
			url[1] == 'push-test'
		) {

			specific_serviceworker.onready();	
		}

		/*
		Get one project
		*/
		if(
			url[1] == 'project'
		) {
			
			/*
			Get: List
			*/
			specific_overview.getList(
				'one',
				'projects',
				url[2]
			);

		}

		/*
		Get one project
		*/
		if(
			url[1] == 'sale'
		) {
			
			/*
			Get: List
			*/
			specific_overview.getList(
				'one',
				'sales',
				url[2]
			);

		}

		/*
		Trigger: Instagram
		*/
		//specific_instagram.onready('thumb',8,true);

		/*
		Trigger: Facebook
		*/
		//specific_facebook.onready(6,true);

		/*
		Popup: Open on load
		*/
		if(url[1] == 'wachtwoord-vergeten') {
			popup.open(1,1,'forgotpassword');
		}

		/*
		Page Loader & Header
		*/
		if(
			url[1] != '' &&
			url[1] != 'wachtwoord-vergeten' &&
			_loggedIn == 0
		) {

			$.ajax({
				url:globalUrl + '/a/l/header',
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {
				
				$('.js-header').html(data).show(0,function() {
				
					/*
					Catch and active URL
					*/
					specific_interactions_init.changeNav();

					$('body').addClass('active');
					$('.js-header').addClass('active');
					$('.js-page-loader').addClass('active');

					/*
					Update livedate
					*/
					specific_date.update();

				});

				/*
				Set: LoggedIn
				*/
				_loggedIn = 1;

			})
			.always(function() {
			});

		} else {

			/*
			Catch and active URL
			*/
			specific_interactions_init.changeNav();

		}

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.changeNav = function() {

		/*
		Catch and active URL
		*/
		var _url_active_main = './';
		
		$('.js-nav-item').removeClass('active');

		if(url[1] !== '') { 
			_url_active_main = url[1];
		}

		// if(url[2] !== '') {
		// 	_url_active_main = url[1] + '/' + url[2];
		// }
		
		if(_url_active_main !== '') {
			$('.js-nav-item[data-go-url="' + _url_active_main + '"]').addClass('active');
		}

	};
	
}).apply(specific_interactions_init); 
